<template>
    <div v-if="qrCodeURL">
        <!-- <qrcode-vue :value="qrCodeURL" :size="size" level="H" v-if="supply === 'รับหน้าร้าน' ||  supply === 'coupon' || (supply === 'link_code' && rewardCode.search('/') === -1)"></qrcode-vue><br> -->
        <v-row>
            <v-col cols="12" class="px-7" v-if="supply === 'รับหน้าร้าน' || supply === 'coupon'">
                <v-btn block color="success" :loading="loading" @click="claimReward()">
                  รับของรางวัล
                </v-btn>
            </v-col>
            <!-- <v-col class="text-center" cols="1" xs="1" sm="1" md="1" lg="1">
                <v-btn :color="$bgColor2"
                fab
                x-small
                dark @click="copyTextformView"><v-icon>mdi-content-copy</v-icon></v-btn>
            </v-col> -->
        </v-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import Swal from 'sweetalert2'
export default {
  name: 'QRCodeUseCodeStamp',
  props: ['rewardId', 'rewardCode', 'lineUserId', 'memberId', 'supply'],
  components: {
    QrcodeVue
  },
  data () {
    return {
      password: '',
      loading: false,
      member: null,
      profile: null,
      qrCodeURL: null,
      size: 150,
      shopId: null,
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          `${this.$t('message.fillNum')}`,
        counterTel: (value) => value.length > 11 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          `${this.$t('message.fillNum')}`,
        required: (value) => !!value || 'กรุณากรอก.',
        passwordRules: (value) => value === 'staff01' || `รหัสผิด`,
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        contract: (value) => {
          if (!value) return true // หรือ false ถ้าต้องการบังคับกรอก
          const pattern = /^[A-Z]{2}\d{1,3}-\d{4}$/

          return pattern.test(value) || 'รูปแบบต้องเป็น ตัวอักษร 2 ตัวใหญ่ - ตัวเลข 4 ตัว เช่น AB-1234'
        },
        empId: (value) => {
          const pattern = /^[a-zA-Z]{2}[0-9]{5}$/
          return pattern.test(value) || 'A-Z 2 + 5 digits EX. (AA12345).'
        },
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  async mounted () {
    this.shopId = this.GET_SHOPID()
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    if (this.shopId !== 'SD_1737957295593') {
      this.qrCodeURL = this.ADMIN_IP + `/Master/trade?shopId=${this.shopId}&rewardId=${this.rewardId}&rewardCode=${this.rewardCode}&memberId=${this.profile.memberId}`
    } else {
      this.qrCodeURL = this.rewardCode
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    copyTextformView () {
      let textToCopyformUpdate = this.$refs.textToCopyformView.$el.querySelector('input')
      textToCopyformUpdate.select()
      document.execCommand('copy')
    },
    async claimReward () {
      try {
        const params = {
          redeemStatus: 'use',
          rewardId: this.rewardId,
          supply: 'redeem',
          rewardCode: this.rewardCode
        }
        this.loading = true
        await this.callBeTaskAPI('post', `/rewardCode/edit`, params)
        // console.log(result)
        Swal.fire({
          icon: 'success',
          title: 'รับของรางวัลเรียบร้อย!',
          text: 'ระบบได้ทำการบันทึกเรียบร้อยแล้ว'
        })
          .then((confirm) => {
            this.loading = true
            if (confirm.isConfirmed) {
              this.$router.push('/home')
            } else {
              this.$router.push('/home')
            }
          })
          .catch((err) => {
            console.error('error', err)
            this.$router.push('/bankPage')
          })
      } catch (error) {
        alert(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QRCodeUseCodeStamp.vue